import type { HBLinkTarget, HBResolvedLink } from './useLinkBehavior.types';

const SCHEME_OR_PROTOCOL_RELATIVE = /^(?:[a-z][a-z\d+.-]*:|\/\/)/i;

/**
 * Classifies a target when the app provides no `resolveLink`. A route object is in-app but has
 * no URL hbui can build. A string with a scheme (`https:`, `mailto:`, `tel:`) or a leading `//`
 * is external. Any other string is an in-app path, which keeps string `to` callers working.
 */
export function defaultResolveLink(to: HBLinkTarget): HBResolvedLink {
    if (typeof to !== 'string') {
        return { isInternal: true };
    }

    return { href: to, isInternal: !SCHEME_OR_PROTOCOL_RELATIVE.test(to) };
}
